export default __webpack_public_path__ + "static/media/pomodoro.dda0f762.gif";